import { render } from "./RolesEditorProjects.vue?vue&type=template&id=22336b4b&scoped=true"
import script from "./RolesEditorProjects.vue?vue&type=script&lang=js"
export * from "./RolesEditorProjects.vue?vue&type=script&lang=js"

import "./RolesEditorProjects.vue?vue&type=style&index=0&id=22336b4b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22336b4b"]])

export default __exports__